import React, { useState, useEffect } from 'react';
import { Typography, RadioGroup, FormControlLabel, Radio, TextField, Box } from '@mui/material';
import ActionDialog from './ActionDialog';
import theme from '../../theme';

const SUSPENSION_REASONS = [
  '성인/도박 등 불법광고 및 스팸 활동',
  '바람직하지 않은 활동(광고, 도배, 욕설, 비방 등)',
];

const UserSuspensionDialog = ({ open, onClose, onConfirm }) => {
  const [selectedReason, setSelectedReason] = useState(SUSPENSION_REASONS[0]);
  const [otherReason, setOtherReason] = useState('');

  useEffect(() => {
    // 다이얼로그가 열릴 때 상태 초기화
    if (open) {
      setSelectedReason(SUSPENSION_REASONS[0]);
      setOtherReason('');
    }
  }, [open]);

  const handleConfirm = () => {
    const reason = selectedReason === 'other' ? otherReason : selectedReason;
    onConfirm(reason);
  };

  return (
    <ActionDialog
      open={open}
      onClose={onClose}
      onConfirm={handleConfirm}
      title="활동 정지"
      confirmText="활동 정지"
      isConfirmDisabled={selectedReason === 'other' && !otherReason.trim()}
    >
      <Typography fontSize={14} color={theme.palette.black[4]} sx={{ mb: 3 }}>
        활동 정지 사유
      </Typography>
      <RadioGroup value={selectedReason} onChange={(e) => setSelectedReason(e.target.value)}>
        {SUSPENSION_REASONS.map((reason, index) => (
          <FormControlLabel
            key={`${reason}-${index}`}
            value={reason}
            control={<Radio size="small" />}
            label={reason}
            sx={{
              '& .MuiFormControlLabel-label': {
                fontSize: 14,
              },
            }}
          />
        ))}
        <Box>
          <FormControlLabel
            value="other"
            control={<Radio size="small" />}
            label="기타 사유"
            sx={{
              '& .MuiFormControlLabel-label': {
                fontSize: 14,
              },
            }}
          />
          <Box>
            <TextField
              placeholder="기타 사유를 입력하세요."
              onClick={() => setSelectedReason('other')}
              onChange={(e) => setOtherReason(e.target.value)}
              value={otherReason}
              fullWidth
              disabled={selectedReason !== 'other'}
              sx={{
                '& .MuiInputBase-input': {
                  fontSize: 14,
                },
                '& .MuiInputBase-input::placeholder': {
                  fontSize: 14,
                },
              }}
            />
          </Box>
        </Box>
      </RadioGroup>
    </ActionDialog>
  );
};

export default UserSuspensionDialog;
